import { Component } from '@angular/core';
import { GamificationBadgeDto } from '../types/GamificationBadgeDto';
import { OeAppService } from '../oe-app.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'lp2-badge-modal',
  templateUrl: './badge-modal.component.html',
  styleUrls: ['./badge-modal.component.scss'],
})
export class BadgeModalComponent {
  curiousFacts: string;

  badge: GamificationBadgeDto;

  topQualify = 10;

  hasTopDescription = true;

  gamificationS3Url = `//${this.oeApp.s3BucketHost()}/gamification`;

  constructor(
    private ngbActiveModal: NgbActiveModal,
    private oeApp: OeAppService
  ) {}

  close() {
    this.ngbActiveModal.close();
  }
}



// WEBPACK FOOTER //
// ./ts/app/shared/badge-modal/badge-modal.component.ts